import { BiEdit } from "react-icons/bi";
import { FaExchangeAlt, FaRegStar } from "react-icons/fa";
import {
  FaChalkboardUser,
  FaDownload,
  FaRegCirclePause,
  FaRegEnvelope,
} from "react-icons/fa6";
import { IoMdPrint } from "react-icons/io";
import {
  IoCheckmarkOutline,
  IoEyeOutline,
  IoPlayOutline,
} from "react-icons/io5";
import { LiaUserSlashSolid, LiaUserSolid } from "react-icons/lia";
import { LuPrinter } from "react-icons/lu";
import { MdLock } from "react-icons/md";
import { RiDeleteBin5Line } from "react-icons/ri";
import { RxAccessibility, RxCross2 } from "react-icons/rx";
import { TbLockQuestion } from "react-icons/tb";
import classes from "./TableActionHandler.module.css";
function TableActionHandler(props) {
  return (
    <div className={classes.tableActions}>
      {Object.entries(props)
        .filter(([_, handler]) => handler)
        .map(([key, handler]) => {
          const Icon = icons[key];
          return (
            Icon && (
              <div
                key={key}
                onClick={handler}
                className={classes?.iconDiv}
                datatype={squareShapes.includes(key) ? key : "basic"}
              >
                {Icon}
              </div>
            )
          );
        })}
    </div>
  );
}

export default TableActionHandler;

const icons = {
  onView: <IoEyeOutline title="View" />,
  onEdit: <BiEdit title="Edit" />,
  onDelete: <RiDeleteBin5Line title="Delete" />,
  onApprove: <IoCheckmarkOutline title="Approve" />,
  onReject: <RxCross2 title="Reject" />,
  onResume: <FaRegCirclePause title="Resume" />,
  onAssign: <FaChalkboardUser title="Assign" />,
  onDownload: <FaDownload title="Download" />,
  onPrint: <LuPrinter title="Print" />,
  onMessage: <FaRegEnvelope title="Send Email" />,
  onActivate: <LiaUserSolid title="Activate" />,
  onDeactivate: <LiaUserSlashSolid title="Deactivate" />,
  onUpdateAccommodation: <RxAccessibility title="View Accommodation" />,
  onOpen: <MdLock title="Unlock" />,
  onResetPassword: <TbLockQuestion title="Reset Password" />,
  // Distinct from Delete on purpose: abandoning keeps everything and only takes
  // the record out of the list.
  onAbandon: <LiaUserSlashSolid title="Abandon" />,
  onPrintPdf: <IoMdPrint title="Print PDF" />,
  onRoleChange: <FaExchangeAlt title="Role Change" />,
  onPlay: <IoPlayOutline title="View" />,
  onMakePrimary: <FaRegStar title="Make Primary Contact" />,
};

const squareShapes = [
  "onView",
  "onDelete",
  "onEdit",
  "onResume",
  "onAssign",
  "onDownload",
  "onPrint",
  "onMessage",
  "onActivate",
  "onDeactivate",
  "onPrintPdf",
  "onPlay",
];
